"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactChartjs = require("react-chartjs-2");
var _chart = require("chart.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
_chart.Chart.register(_chart.ArcElement, _chart.Tooltip, _chart.Legend);

//Pie chart logic implementation
function Piechart(_ref) {
  let {
    data,
    options,
    style,
    backstyle
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: backstyle
  }, /*#__PURE__*/_react.default.createElement(_reactChartjs.Pie, {
    data: data,
    options: options,
    width: style.width,
    height: style.height
  }));
}
var _default = exports.default = Piechart;